// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"f19d817d","178":"96967ce1","717":"b5bb9da6"}[chunkId] + ".chunk.css";
};